/*
=============================================================================
BKNJ PDP MERCHANDISING — COMPLETE THE LOOK CONTROLLER
Target Shopify file: assets/bknj-pdp-merchandising-complete-look.js

PDP ONLY.
Complete The Look remains on the product page, but it is never injected into the
cart drawer. The cart should contain purchased products only.
=============================================================================
*/
(function(window, document){
  'use strict';

  if (window.BKNJCompleteLookMerch && window.BKNJCompleteLookMerch.version) return;

  var api = { version:'3.0.0-pdp-only' };

  function qs(selector, root){ return (root || document).querySelector(selector); }
  function qsa(selector, root){ return Array.prototype.slice.call((root || document).querySelectorAll(selector)); }
  function closest(el, selector){ return el && el.closest ? el.closest(selector) : null; }

  function formatMoney(cents){
    cents = Number(cents || 0);
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      var format = window.BKNJ_CART_MONEY_FORMAT || window.money_format || (window.theme && window.theme.moneyFormat);
      if (format) return window.Shopify.formatMoney(cents, format);
    }
    var currency = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
    try { return (cents / 100).toLocaleString(undefined, { style:'currency', currency:currency }); }
    catch(error){ return (cents / 100).toFixed(2) + ' ' + currency; }
  }

  function cleanVariantTitle(title){ return String(title || '').replace(/\s+-\s+Sold Out\s*$/i, '').trim(); }

  function setMessage(target, text, error){
    if (!target) return;
    target.textContent = text || '';
    target.classList.toggle('is-error', !!error);
  }

  function notifyContext(form){
    var item = closest(form, '[data-bknj-complete-look-item]');
    var titleLink = item ? qs('.bknj-jh-complete-look__title', item) : null;
    var select = qs('[data-bknj-complete-look-select]', form);
    var selected = select ? select.options[select.selectedIndex] : null;
    var variantInput = qs('[data-bknj-complete-look-variant], input[name="id"]', form);
    return {
      source:'PDP Complete The Look',
      productTitle:titleLink ? titleLink.textContent.trim() : '',
      productUrl:titleLink && titleLink.href ? titleLink.href : window.location.href,
      variantTitle:selected ? cleanVariantTitle(selected.textContent) : '',
      variantId:selected ? selected.value : (variantInput ? variantInput.value : '')
    };
  }

  function submitNotify(email, context, message, button, done){
    email = String(email || '').trim();
    if (!email || email.indexOf('@') === -1) { setMessage(message, 'Please enter a valid email address.', true); return; }
    if (button) button.disabled = true;

    var data = new FormData();
    data.append('form_type','contact');
    data.append('contact[email]',email);
    data.append('contact[body]',[
      'Notify me when available request','',
      'Source: ' + (context.source || ''),
      'Product: ' + (context.productTitle || ''),
      'Product URL: ' + (context.productUrl || window.location.href),
      'Variant: ' + (context.variantTitle || ''),
      'Variant ID: ' + (context.variantId || '')
    ].join('\n'));

    fetch('/contact',{method:'POST',credentials:'same-origin',body:data,headers:{'Accept':'text/html'}})
      .then(function(response){ if (!response.ok) throw new Error('Contact form failed'); return response.text(); })
      .then(function(){ setMessage(message,'',false); if (done) done(); })
      .catch(function(){ setMessage(message,'Something went wrong. Please try again.',true); })
      .finally(function(){ if (button) button.disabled = false; });
  }

  function addForm(form){
    if (window.BKNJCart && typeof window.BKNJCart.addForm === 'function') return window.BKNJCart.addForm(form);
    return fetch('/cart/add.js',{method:'POST',credentials:'same-origin',headers:{'Accept':'application/json'},body:new FormData(form)})
      .then(function(response){ if (!response.ok) return response.json().then(function(error){ throw error; }); return response.json(); });
  }

  function refreshCart(){
    if (window.BKNJCart && typeof window.BKNJCart.refresh === 'function') return window.BKNJCart.refresh();
    return fetch('/cart.js',{credentials:'same-origin',headers:{'Accept':'application/json'}}).then(function(response){ return response.json(); });
  }

  function resetAvailability(form){
    var select = qs('[data-bknj-complete-look-select]', form);
    var add = qs('[data-bknj-complete-look-add]', form);
    var bell = qs('[data-bknj-complete-look-notify-bell]', form);
    var panel = qs('[data-bknj-complete-look-notify]', form);
    var available = true;

    if (select) {
      var selected = select.options[select.selectedIndex];
      available = !!(selected && selected.getAttribute('data-available') === 'true');
    } else if (add) {
      available = !add.hasAttribute('data-bknj-forced-unavailable') && !add.disabled;
    }

    if (add) add.disabled = !available;
    if (bell) bell.hidden = available;
    if (panel && available) panel.hidden = true;
  }

  function initPdpWrap(wrap){
    if (!wrap || wrap.__bknjCompleteLookInit) return;
    wrap.__bknjCompleteLookInit = true;

    var items = qsa('[data-bknj-complete-look-item]',wrap);
    var next = qs('[data-bknj-complete-look-next]',wrap);
    var track = qs('.bknj-jh-complete-look__items',wrap);

    if (items.length > 1) wrap.classList.add('has-multiple');

    function show(index){
      if (!items.length) return;
      items.forEach(function(item,i){ item.classList.toggle('is-active',i===index); });
      if (track) track.style.transform='translateX(-'+(index*100)+'%)';
      wrap.setAttribute('data-active-index',String(index));
    }

    show(0);

    if (next && items.length>1) {
      next.addEventListener('click',function(){
        var current=parseInt(wrap.getAttribute('data-active-index')||'0',10);
        show((current+1)%items.length);
      });
    }

    qsa('[data-bknj-complete-look-select]',wrap).forEach(function(select){
      select.addEventListener('change',function(){
        var form=closest(select,'[data-bknj-complete-look-form]');
        var selected=select.options[select.selectedIndex];
        var item=closest(select,'[data-bknj-complete-look-item]');
        var price=item?qs('[data-bknj-complete-look-price]',item):null;
        if (price && selected) price.textContent=formatMoney(parseInt(selected.getAttribute('data-price')||'0',10));
        if (form) resetAvailability(form);
      });
    });

    qsa('[data-bknj-complete-look-form]',wrap).forEach(function(form){
      resetAvailability(form);

      var bell=qs('[data-bknj-complete-look-notify-bell]',form);
      var panel=qs('[data-bknj-complete-look-notify]',form);
      var email=qs('[data-bknj-complete-look-notify-email]',form);
      var notifyButton=qs('[data-bknj-complete-look-notify-submit]',form);
      var message=qs('[data-bknj-complete-look-message]',form);

      if (bell && panel) bell.addEventListener('click',function(){ panel.hidden=false; if(email) email.focus(); });
      if (notifyButton) notifyButton.addEventListener('click',function(){
        submitNotify(email?email.value:'',notifyContext(form),message,notifyButton,function(){
          if(panel) panel.hidden=true;
          if(email) email.value='';
        });
      });

      form.addEventListener('submit',function(event){
        event.preventDefault();
        var add=qs('[data-bknj-complete-look-add]',form);
        if (add && add.disabled) return;
        setMessage(message,'',false);
        if(add) add.classList.add('is-loading');

        addForm(form)
          .then(function(){
            if(window.BKNJCart && typeof window.BKNJCart.open==='function') return window.BKNJCart.open({allowEmpty:true});
            return refreshCart();
          })
          .catch(function(error){
            setMessage(message,error&&error.description?error.description:'Something went wrong. Please try again.',true);
          })
          .finally(function(){
            if(add) add.classList.remove('is-loading');
            resetAvailability(form);
          });
      });
    });
  }

  function removeLegacyCartLook(){
    qsa('[data-bknj-cart-complete-look]').forEach(function(el){ el.remove(); });
    qsa('#bknj-cart-drawer-d, #bknj-cart-drawer').forEach(function(drawer){
      drawer.classList.remove('bknj-cart--has-complete-look');
    });
  }

  function init(){
    removeLegacyCartLook();
    qsa('[data-bknj-complete-look]').forEach(initPdpWrap);
  }

  document.addEventListener('bknj:cart:ready',removeLegacyCartLook);
  document.addEventListener('shopify:section:load',init);
  if(document.readyState==='loading') document.addEventListener('DOMContentLoaded',init);
  else init();

  api.init=init;
  window.BKNJCompleteLookMerch=api;
})(window,document);
